<template>
  <div style="overflow: hidden;" id="app">
    <div style="display: flex; flex-direction: row; height: 100%; ">
      <div
        v-if="device === 'mobile' && !isCollapse"
        style="position: relative; min-width: 210px;"
        class="sidebar-container mobile"
      >
        <el-row class="rowTop">
          <span
            style="width: 100%; text-align: left; color: #000; font-size: 18px; font-weight: normal;"
            >Hi, {{ username }}</span
          >
        </el-row>
        <el-row class="rowTop4">
          <div
            style="display: flex; width: 100%; justify-content: center; align-items: flex-start; flex-direction: column; margin-bottom: 4px;"
          >
            <el-button @click="() => switchCompany()" type="primary" size="mini"
              >Switch Company</el-button
            >
          </div>
          <div
            style="display: flex; flex-direction: column; width: 100%;"
            v-if="branchData"
          >
            <span
              v-if="branchData.regionId"
              style="width: 100%; text-align: left; color: #000; font-size: 14px; margin-bottom: 4px; margin-top: 4px;"
              >{{ branchData.regionId.companyId && branchData.regionId.companyId.name ? branchData.regionId.companyId.name : "-" }}</span
            >
            <span
              v-if="branchData.relation"
              style="width: 100%; text-align: left; color: #000; font-size: 14px; margin-bottom: 4px; margin-top: 4px;"
              >{{ branchData.relation.role }}</span
            >
            <!-- <span
              v-if="branchData.region"
              style="width: 100%; text-align: left; color: #000; font-size: 14px; margin-bottom: 4px;"
              >{{ branchData.region.name }}</span
            >
            <span
              style="width: 100%; text-align: left; color: #000; font-size: 14px;"
              >{{ branchData.name }}</span
            > -->
          </div>
        </el-row>
        <el-scrollbar wrapClass="scrollbar-wrapper">
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <sidebar-item :routes="permission_routers"></sidebar-item>
          </el-menu>
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <div class="menu-wrapper">
              <template>
                <div v-if="branchSelected" @click="projectLeave()">
                  <el-menu-item
                    index="/projects"
                    :class="{ 'submenu-title-noDropdown': true }"
                  >
                    <i class="el-icon-back"></i>
                    <span slot="title">
                      Projects
                    </span>
                  </el-menu-item>
                </div>
                <el-menu-item
                  index="/logout"
                  @click="logout"
                  class="submenu-title-noDropdown"
                >
                  <i style="color: #000;" class="el-icon-switch-button"></i>
                  <span slot="title">Log Out</span>
                </el-menu-item>
              </template>
            </div>
          </el-menu>
        </el-scrollbar>
      </div>
      <div
        :style="
          device === 'mobile' && globalSidebar === true
            ? 'left: 240px; position: absolute;'
            : ''
        "
        style="display: flex; flex-direction: column; height: 100%; width: 100%;"
      >
        <header v-if="burgerAllowed" style="height: 65px;">
          <div class="headerClass">
            <div
              style="display: flex; flex: 1; align-items: center; justify-content: flex-start; flex-direction: row;"
            >
              <!-- <span>{{ branchLogo.toString() }}</span> -->
              <a href="/">
                <img class="appLogo" :src="defaultLogo" />
                <!-- <span style="color: #fff; font-size: 28px; font-weight: bold;">ITXCRADLEAI</span> -->
              </a>
            </div>
            <nav
              v-if="device !== 'mobile'"
              style="flex: 2; display: flex; justify-content: flex-start; align-items: center;"
            >
              <div style="width: 100%;">
                <ul
                  style="display: flex; list-style: none; margin: 0; padding: 0; flex-direction: row; flex-wrap: wrap;"
                >
                  <!-- <li style="padding: 0; flex: 1;">
                    <a href="/" class="headerLink">HOME</a>
                  </li> -->
                </ul>
              </div>
            </nav>
            <div
              v-if="token === '' && device !== 'mobile'"
              style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: center;"
            ></div>
            <div
              v-else-if="device !== 'mobile'"
              style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: center;"
            >
              <el-dropdown style="margin-left: 10px;" trigger="click">
                <span
                  style="display: flex; flex-direction: row; justify-content: center; align-items: center; cursor: pointer; color: var(--primary2-color);"
                >
                  <!-- <i class="el-icon-user-solid"></i> -->
                  <img
                    v-if="profilePicture"
                    style="display: flex; width: 35px; height: 35px; margin-right: 12px;"
                    :src="profilePicture"
                  />
                  <div
                    v-else
                    style="display: flex; width: 35px; height: 35px; margin-right: 12px; background-color: #000;"
                  ></div>
                  <span style="display: flex; width: 100%; height: 100%;"
                    >{{ awakRole !== "none" ? username : username }}
                    <i class="el-icon-caret-bottom"></i
                  ></span>
                </span>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                  <el-dropdown-item>
                    <span @click="logout" style="display:block;">Log Out</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <span
                class="colorModeDiv"
              >
                <svg-icon icon-class="sun" :class="!tempColorMode ? 'active' : ''" />
                <el-switch
                  :value="tempColorMode"
                  @change="toggleColorMode"
                  style="margin-left: 5px; margin-right: 5px;"
                  active-color="#00FF41"
                  inactive-color="#DCDFE6">
                </el-switch>
                <svg-icon icon-class="moon" :class="tempColorMode ? 'active' : ''" />
              </span> -->
            </div>
            <hamburger
              v-if="device === 'mobile'"
              style="position: relative; display: flex; flex-direction: row;"
              class="hamburger-container"
              :toggleClick="toggleGlobalSideBar"
              :isActive="globalSidebar.opened"
            ></hamburger>
          </div>
        </header>
        <div ref="routerParent" @click="handleClickOutside()" style="flex: 1; overflow: scroll;">
          <router-view :switchCompany="switchCompany" :nextBranch="nextBranch"></router-view>
        </div>
      </div>
    </div>
    <footer>
      <!-- <cookie-law theme="xfero"></cookie-law> -->
    </footer>
    <el-dialog
      v-loading="signInLoading"
      :visible.sync="signInPopup.opened"
      :before-close="signInClose"
      title=""
      width="300px"
    >
      <p
        style="color: #000; font-size: 21px; margin: 0px 0px; text-align: center;"
      >
        Sign in to
      </p>
      <p
        class="titleColor"
        style="font-size: 36px; margin: 40px 0px; font-family: CaviarDreams; font-weight: bold; text-align: center; margin-top: 30px; margin-bottom: 20px;"
      >
        {{ title }}
      </p>
      <div
        @click="google"
        style="display: flex; flex-direction: row; width: 100%; height: 50px; border-radius: 4px; margin-top: 20px; padding: 2px; cursor: pointer;"
        :style="
          agePermission
            ? 'background-color: #4285f4; cursor: pointer;'
            : 'background-color: #ccc; cursor: default;'
        "
      >
        <div
          style="display: flex; justify-content: center; align-items: center; width: 60px; background-color: #fff;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 533.5 544.3"
            style="width: 18px;"
          >
            <path
              d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
              fill="#4285f4"
            ></path>
            <path
              d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
              fill="#34a853"
            ></path>
            <path
              d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
              fill="#fbbc04"
            ></path>
            <path
              d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
              fill="#ea4335"
            ></path>
          </svg>
        </div>
        <div
          style="flex: 1; display: flex; justify-content: center; align-items: center;"
        >
          <span style="color: #fff; font-weight: 500;">Google</span>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 10px;"
      >
        <span
          @click="
            agePermission ? (agePermission = false) : (agePermission = true)
          "
          style="width: 100%; text-align: center; cursor: pointer;"
          ><el-checkbox style="margin-right: 10px;" v-model="agePermission" />I
          confirm that I am at least <b>18</b> years old, or at least 13 years
          old <b>with</b> parental permission to use this website.</span
        >
        <!-- <span><el-checkbox v-model="agePermission"/>I agree</span> -->
      </div>
    </el-dialog>
    <el-dialog
      title="Switch Company Branch"
      :visible.sync="userBranch"
      :before-close="resetForm"
    >
      <!-- <el-form ref="currUser2" :model="currUser2"> -->
      <div style="display: flex; flex-direction: row; width: 100%; padding-left: 2px; padding-right: 2px;">
        <el-input class="border2px" placeholder="Search" style="width: 100%; margin-left: 0px;" @change="()=>searchBranch()" v-model="branchSearch">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <el-button
          style="margin-left: 10px;"
          type="primary"
          size="mini"
          icon="el-icon-search"
        ></el-button> -->
      </div>
      <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; flex-wrap: wrap; overflow: hidden; padding-left: 0px; padding-right: 0px; padding-top: 10px;" v-if="!branchLoading">
        <el-button class="tagButton" :style="`background-color: ${currUser2.company === item._id ? 'var(--bg11-color)' : 'rgba(0,0,0,0)'}; color: ${currUser2.company === item._id ? 'var(--primary4-color)' : 'var(--bg11-color)'};`" v-for="(item, key) in filteredCompanies" :key="key" @click="()=>{
            if (currUser2.company !== item._id) {
              currUser2.company = item._id;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
          {{ item.relationId ? item.relationId.name : '-' }}
        </el-button>
        <!-- <div
          class="companyList"
          v-for="(item, key) in filteredCompanies"
          :key="key">
          <div
          class="companyButton"
          :class="currUser2.company === item._id ? 'active' : 'inactive'"
          @click="() => {
            if (currUser2.company !== item._id) {
              currUser2.company = item._id;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
            <p>{{item.relationId ? item.relationId.name : '-'}}</p>
          </div>
        </div> -->
      </div>
      <!-- <span>seperator</span>
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;" v-if="!branchLoading">
        <div
          class="companyList"
          v-for="(item, key) in companies"
          :key="key">
          <div
          class="companyButton"
          :class="currUser2.company === key ? 'active' : 'inactive'"
          @click="() => {
            if (currUser2.company !== key) {
              currUser2.company = key;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
            <p>{{item.relationId ? item.relationId.name : '-'}}</p>
          </div>
        </div>
      </div> -->
      <!-- <el-form-item label="Company">
        <el-select
          @change="
            () => {
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          "
          class="el-input-size"
          v-model="currUser2.company"
        >
          <el-option
            :value="null"
            label="- Select -"
          >
            - Select -
          </el-option>
          <el-option
            v-for="(item, key) in companies"
            :key="key"
            :value="key"
            :label="item.name"
          >
            {{ item.relationId ? item.relationId.name : '-' }}
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="Region">
        <el-select
          :disabled="true"
          @change="
            () => {
              currUser2.branch = 0;
            }
          "
          class="el-input-size"
          v-model="currUser2.region"
        >
          <div v-if="companies.length > 0 && currUser2.company !== null">
            <el-option
              v-for="(item, key) in companies[currUser2.company].regions"
              :key="key"
              :value="key"
              :label="item.name"
            >
              {{ item.name }}
            </el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="Branch">
        <el-select
          :disabled="true"
          class="el-input-size"
          v-model="currUser2.branch"
        >
          <div v-if="companies.length > 0 && companies[currUser2.company].regions.length > 0 && currUser2.region !== null">
            <el-option
              v-for="(item, key) in companies[currUser2.company].regions[currUser2.region].branches"
              :key="key"
              :value="key"
              :label="item.name"
            >
              {{ item.name }}
            </el-option>
          </div>
        </el-select>
      </el-form-item> -->
      <!-- </el-form> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm">Cancel</el-button>
        <!-- <el-button v-loading="btnloading" type="primary" @click="selectBranch"
          >Confirm</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import Hamburger from "@/components/Hamburger";
import { mapGetters } from "vuex";
import SidebarItem from "./views/admin/layout/components/Sidebar/SidebarItem";
import defaultLogo from "./assets/sirim-blue.jpg";
import coloredLogo from "./assets/outwork-green.png";
// import sun from './icons/svg/sun.svg'
// import moon from './icons/svg/moon.svg'
import "@/permission";
import ResizeMixin from "@/mixin/ResizeHandler";
import moment from "moment";
import Cookies from 'js-cookie'
// import SocketIO from 'socket.io-client'

export default {
  name: "App",
  components: { CookieLaw, Hamburger, SidebarItem },
  mixins: [ResizeMixin],
  data() {
    return {
      title: process.env.APP_NAME.toUpperCase(),
      appname: process.env.APP_NAME,
      currUser2: {
        company: null,
        region: 0,
        branch: 0
      },
      logo: null,
      year: "",
      filteredCompanies: [],
      branchSearch: "",
      branchLoading: false,
      // notificationSocket: null,
      signInLoading: false,
      agePermission: false,
      userBranch: false,
      // colorMode: false,
      refreshPageAfter: false,
      defaultLogo,
      coloredLogo,
      tempColorMode: false,
      // sun,
      // moon
    };
  },
  methods: {
    toggleGlobalSideBar() {
      this.$store.dispatch("ToggleGlobalSideBar");
    },
    toggleColorMode() {
      this.$store.dispatch("ToggleColorMode");
      this.tempColorMode = !this.tempColorMode
    },
    // login() {
    //   this.$router.push('/login')
    // },
    // register() {
    //   this.$router.push('/register')
    // },
    // dashboard() {
    //   this.$router.push('/dashboard')
    // },
    signIn() {
      this.$store.dispatch("OpenSignInPopup", { subscribe: false });
    },
    signInClose() {
      this.$store.dispatch("CloseSignInPopup");
    },
    branchLeave() {
      this.$store.dispatch("SetBranchSelected", null).then(() => {
        this.$store.dispatch("ClearRoutes").then(() => {
          this.$router.push("/projects");
        });
      });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$store.dispatch("ResetRoutes").then(() => {
          this.$router.push("/?logout=true");
        });
      });
    },
    handleClickOutside() {
      this.$store.dispatch("CloseGlobalSideBar", { withoutAnimation: false });
    },
    google() {
      if (this.agePermission) {
        this.signInLoading = true;
      }
    },
    kick(route) {
      this.$router.push(route);
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
    searchBranch() {
      // console.log(this.branchSearch)
      // console.log(this.companies)
      this.branchLoading = true;
      this.filteredCompanies = this.companies.filter((company) => {
        return company && company.relationId && company.relationId.name ? company.relationId.name.toLowerCase().includes(this.branchSearch.toLowerCase()) : false;
      });
      // console.log(this.filteredCompanies)
      this.$nextTick(() => {
        this.branchLoading = false;
      })
    },
    resetForm() {
      this.userBranch = false;
      // this.currUser2 = {
      //   company: null,
      //   region: 0,
      //   branch: 0
      // }
    },
    async selectBranch() {
      // this.$store
      //   .dispatch(
      //     "SetBranchSelected",
      //     this.companies[this.currUser2.company].relationId.regions[this.currUser2.region]
      //       .branches[this.currUser2.branch]._id
      //   )
      //   .then(() => {
      //     // this.$store.dispatch("ClearRoutes").then(() => {
      //     //   this.$router.push("/bookings");
      //     // });
      //     location.reload();
      //     // this.$router.push("/");
      //   });
      this.userBranch = false;
			const index = this.filteredCompanies.findIndex((v) =>  v._id === this.currUser2.company)
      this.$router.push(`/z/${
        this.filteredCompanies[index].relationId.regions[this.currUser2.region]
          .branches[this.currUser2.branch]._id
      }/default?refresh=1`)
      // this.refreshPageAfter = true
      // this.$router.push('/account?refresh=true')
      this.currUser2 = {
        company: null,
        region: 0,
        branch: 0
      }
      // this.$router.push('/account')
      // location.reload();
    },
    nextBranch() {
      const companies = this.filteredCompanies
      let key = this.currUser2.company
      let item = null
      
      if (companies.length > 0) {
        // console.log("App Before")
        // console.log(this.$store.state.app.branchSelected)
        key = key + 1
        if (key == companies.length) {
          key = 0
        }
        item = companies[key]
        // console.log(item.relationId.regions[this.currUser2.region]
        //       .branches[this.currUser2.branch]._id)
        // console.log(servers)
        // console.log(key)
        // console.log(item)
        this.$store
          .dispatch(
            "GetBranch",
            companies[key].relationId.regions[this.currUser2.region]
              .branches[this.currUser2.branch]._id
          )
        // console.log("App After")
        // console.log(this.$store.state.app.branchSelected)
        this.currUser2.company = key
        // console.log("switch")
        // console.log(companies)
        // console.log(key)
        // console.log(item)
        // console.log(this.$store.state.user.branchData)
        return item.relationId.regions[this.currUser2.region]
              .branches[this.currUser2.branch]._id
      }
      return null
      // console.log("switch")
    },
    switchCompany() {
      this.userBranch = true;
      // console.log("this.filteredCompanies", this.filteredCompanies)
      if (this.filteredCompanies && this.filteredCompanies.length > 0 && this.$store.state.user.branchData) {
				const index = this.filteredCompanies.findIndex((v) => this.$store.state.user.branchData.relation && v._id === this.$store.state.user.branchData.relation._id)
				// console.log(index)
        this.currUser2.company = index !== null ? this.filteredCompanies[index]._id : null
				// console.log(this.currUser2.company)
      }
      // console.log("this.currUser2.company", this.currUser2.company)
    },
    log(key, message) {
      console.log(key, message)
    }
  },
  computed: {
    username() {
      return this.$store.state.user.username;
    },
    token() {
      return this.$store.state.user.token;
    },
    companies() {
      return this.$store.state.user.companies.sort((a, b) => {
        if (a.relationId && b.relationId) {
          if (a.relationId.name < b.relationId.name) {
            return -1
          }
          if (a.relationId.name > b.relationId.name) {
            return 1
          }
        }

        return 0
      });
    },
    globalSidebar() {
      return this.$store.state.app.globalSidebar;
    },
    branchData() {
      return this.$store.state.user.branchData
        ? this.$store.state.user.branchData
        : {};
    },
    branchLogo() {
      return this.$store.state.user.branchLogo;
    },
    features() {
      return this.$store.state.user.features;
    },
    branchSelected() {
      return this.$store.state.app.branchSelected;
    },
    signInPopup() {
      return this.$store.state.app.signInPopup;
    },
    device() {
      return this.$store.state.app.device;
    },
    isCollapse() {
      return !this.$store.state.app.globalSidebar.opened;
    },
    burgerAllowed() {
      return this.$store.state.app.burgerAllowed;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    userData() {
      return this.$store.state.user.userData;
    },
    profilePicture() {
      return this.$store.state.user.profilePicture;
    },
    colorMode() {
      return this.$store.state.app.colorMode;
    },
    ...mapGetters(["permission_routers"])
  },
  filters: {
    roleFilter(val) {
      if (val !== "none") {
        return val[0].toUpperCase() + val.substring(1);
      } else {
        return "Manager";
      }
    }
  },
  mounted() {
    // console.log('app branchSelected', this.$store.state.app.branchSelected)
    this.year = moment().format("YYYY");
    this.logo = null
    this.filteredCompanies = this.companies

    this.tempColorMode = this.colorMode === 1 ? true : false;

    if (this.colorMode) {
      document.documentElement.style.setProperty('--bg-color', "#111111");
      document.documentElement.style.setProperty('--bg2-color', "#000000");
      document.documentElement.style.setProperty('--bg3-color', "rgba(51,51,51,.9)");
      document.documentElement.style.setProperty('--bg4-color', "#222222");
      document.documentElement.style.setProperty('--bg5-color', "#333333");
      document.documentElement.style.setProperty('--bg6-color', "#00FF41");
      document.documentElement.style.setProperty('--bg7-color', "#666666");
      document.documentElement.style.setProperty('--bg8-color', "#111111");
      document.documentElement.style.setProperty('--bg9-color', "#353535");
      document.documentElement.style.setProperty('--bg10-color', "#111111");
      document.documentElement.style.setProperty('--bg11-color', "#00FF41");
      document.documentElement.style.setProperty('--bg12-color', "#000000");
      document.documentElement.style.setProperty('--bg13-color', "#000000");
      document.documentElement.style.setProperty('--primary-color', "#00FF41");
      document.documentElement.style.setProperty('--primary2-color', "#000000");
      document.documentElement.style.setProperty('--primary3-color', "#ffffff");
      document.documentElement.style.setProperty('--primary4-color', "#00FF41");
      document.documentElement.style.setProperty('--primary5-color', "#00FF41");
      document.documentElement.style.setProperty('--primary6-color', "#00FF41");
      document.documentElement.style.setProperty('--primary7-color', "#2caa4a");
      document.documentElement.style.setProperty('--primary8-color', "#00FF41");
      document.documentElement.style.setProperty('--primary9-color', "#000000");
      document.documentElement.style.setProperty('--primary10-color', "#000000");
      document.documentElement.style.setProperty('--primary11-color', "#000000");
      document.documentElement.style.setProperty('--secondary1-active-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary1-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary2-active-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary2-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary3-active-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
      document.documentElement.style.setProperty('--secondary4-active-color', "#111111");
      document.documentElement.style.setProperty('--secondary4-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary5-active-color', "#2caa4a");
      document.documentElement.style.setProperty('--secondary5-inactive-color', "#2caa4a");
      document.documentElement.style.setProperty('--secondary6-active-color', "#2e6555");
      document.documentElement.style.setProperty('--secondary6-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--table-border-color', "#333333");
    } else {
      document.documentElement.style.setProperty('--bg-color', "#EEEEEE");
      document.documentElement.style.setProperty('--bg2-color', "#000000");
      document.documentElement.style.setProperty('--bg3-color', "rgba(255,255,255,.9)");
      document.documentElement.style.setProperty('--bg4-color', "#EEEEEE");
      document.documentElement.style.setProperty('--bg5-color', "#EEEEEE");
      document.documentElement.style.setProperty('--bg6-color', "#273E95");
      document.documentElement.style.setProperty('--bg7-color', "#ffffff");
      document.documentElement.style.setProperty('--bg8-color', "#f3ad15");
      document.documentElement.style.setProperty('--bg9-color', "#273E95");
      document.documentElement.style.setProperty('--bg10-color', "#273E95");
      document.documentElement.style.setProperty('--bg11-color', "#273E95");
      document.documentElement.style.setProperty('--bg12-color', "#273E95");
      document.documentElement.style.setProperty('--bg13-color', "#d2dceb");
      document.documentElement.style.setProperty('--primary-color', "#000000");
      document.documentElement.style.setProperty('--primary2-color', "#ffffff");
      document.documentElement.style.setProperty('--primary3-color', "#000000");
      document.documentElement.style.setProperty('--primary4-color', "#d2dceb");
      document.documentElement.style.setProperty('--primary5-color', "#273E95");
      document.documentElement.style.setProperty('--primary6-color', "#ffffff");
      document.documentElement.style.setProperty('--primary7-color', "#ffffff");
      document.documentElement.style.setProperty('--primary8-color', "#f3ad15");
      document.documentElement.style.setProperty('--primary9-color', "#000000");
      document.documentElement.style.setProperty('--primary10-color', "#d2dceb");
      document.documentElement.style.setProperty('--primary11-color', "#273E95");
      document.documentElement.style.setProperty('--secondary1-active-color', "#C0C4CC");
      document.documentElement.style.setProperty('--secondary1-inactive-color', "#000000");
      document.documentElement.style.setProperty('--secondary2-active-color', "#909399");
      document.documentElement.style.setProperty('--secondary2-inactive-color', "#606266");
      document.documentElement.style.setProperty('--secondary3-active-color', "#5379f1");
      document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
      document.documentElement.style.setProperty('--secondary4-active-color', "#ffffff");
      document.documentElement.style.setProperty('--secondary4-inactive-color', "#273E95");
      document.documentElement.style.setProperty('--secondary5-active-color', "#5379f1");
      document.documentElement.style.setProperty('--secondary5-inactive-color', "#000000");
      document.documentElement.style.setProperty('--secondary6-active-color', "#5379f1");
      document.documentElement.style.setProperty('--secondary6-inactive-color', "#5379f1");
      document.documentElement.style.setProperty('--table-border-color', "#EBEEF5");
    }
    // console.log("branchData", this.branchData)
    // if (this.branchData.logo) {
    //   this.logo = this.branchData.logo.path
    // }
    // console.log("branchData2", this.$store.state.user.branchData
    //     ? this.$store.state.user.branchData
    //     : {})
    // this.colorMode = false
    // console.log(this.$store.state.user.features)
    // if (this.$store.state.app.branchSelected) {
    //   this.notificationSocket = SocketIO.connect(process.env.BASE_API, {
    //     path: '/serviceNotifications-admin-socket.io',
    //     query: `token=${this.token}`
    //   })
    //   this.notificationSocket.on('connect', () => {
    //     console.log('connected')
    //     this.notificationSocket.emit('join', this.$store.state.app.branchSelected)
    //   })
    //   this.notificationSocket.on('newNotification', (data) => {
    //     console.log('app', data)
    //     this.$store.dispatch('GetUnreadMessages', this.$store.state.app.branchSelected)
    //   })
    // }
    // console.log(typeof this.notificationSocket)
    // console.log("company", this.currUser2.company)
    // console.log("branchData", this.$store.state.user.branchData)
    // console.log("filteredCompanies", this.filteredCompanies)
    // console.log("companies", this.companies)
  },
  // destroyed() {
  //   this.notificationSocket.disconnect()
  // },
  watch: {
    colorMode(to, from) {
      if (to === true) {
        document.documentElement.style.setProperty('--bg-color', "#111111");
        document.documentElement.style.setProperty('--bg2-color', "#000000");
        document.documentElement.style.setProperty('--bg3-color', "rgba(51,51,51,.9)");
        document.documentElement.style.setProperty('--bg4-color', "#222222");
        document.documentElement.style.setProperty('--bg5-color', "#333333");
        document.documentElement.style.setProperty('--bg6-color', "#00FF41");
        document.documentElement.style.setProperty('--bg7-color', "#666666");
        document.documentElement.style.setProperty('--bg8-color', "#111111");
        document.documentElement.style.setProperty('--bg9-color', "#353535");
        document.documentElement.style.setProperty('--bg10-color', "#111111");
        document.documentElement.style.setProperty('--bg11-color', "#f3ad15");
        document.documentElement.style.setProperty('--bg12-color', "#000000");
        document.documentElement.style.setProperty('--bg13-color', "#000000");
        document.documentElement.style.setProperty('--primary-color', "#00FF41");
        document.documentElement.style.setProperty('--primary2-color', "#000000");
        document.documentElement.style.setProperty('--primary3-color', "#ffffff");
        document.documentElement.style.setProperty('--primary4-color', "#00FF41");
        document.documentElement.style.setProperty('--primary5-color', "#00FF41");
        document.documentElement.style.setProperty('--primary6-color', "#00FF41");
        document.documentElement.style.setProperty('--primary7-color', "#2caa4a");
        document.documentElement.style.setProperty('--primary8-color', "#00FF41");
        document.documentElement.style.setProperty('--primary9-color', "#000000");
        document.documentElement.style.setProperty('--primary10-color', "#000000");
        document.documentElement.style.setProperty('--primary11-color', "#000000");
        document.documentElement.style.setProperty('--secondary1-active-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary1-inactive-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary2-active-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary2-inactive-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary3-active-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
        document.documentElement.style.setProperty('--secondary4-active-color', "#111111");
        document.documentElement.style.setProperty('--secondary4-inactive-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary5-active-color', "#2caa4a");
        document.documentElement.style.setProperty('--secondary5-inactive-color', "#2caa4a");
        document.documentElement.style.setProperty('--secondary6-active-color', "#2e6555");
        document.documentElement.style.setProperty('--secondary6-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--table-border-color', "#333333");
      } else {
        document.documentElement.style.setProperty('--bg-color', "#273E95");
        document.documentElement.style.setProperty('--bg2-color', "#000000");
        document.documentElement.style.setProperty('--bg3-color', "rgba(255,255,255,.9)");
        document.documentElement.style.setProperty('--bg4-color', "#EEEEEE");
        document.documentElement.style.setProperty('--bg5-color', "#273E95");
        document.documentElement.style.setProperty('--bg6-color', "#5379f1");
        document.documentElement.style.setProperty('--bg7-color', "#000000");
        document.documentElement.style.setProperty('--bg8-color', "#000000");
        document.documentElement.style.setProperty('--bg9-color', "#273E95");
        document.documentElement.style.setProperty('--bg10-color', "#273E95");
        document.documentElement.style.setProperty('--bg11-color', "#4F3932");
        document.documentElement.style.setProperty('--bg12-color', "#4F3932");
        document.documentElement.style.setProperty('--bg13-color', "#F3DAA2");
        document.documentElement.style.setProperty('--primary-color', "#ffffff");
        document.documentElement.style.setProperty('--primary2-color', "#ffffff");
        document.documentElement.style.setProperty('--primary3-color', "#ffffff");
        document.documentElement.style.setProperty('--primary4-color', "#F3DAA2");
        document.documentElement.style.setProperty('--primary5-color', "#000000");
        document.documentElement.style.setProperty('--primary6-color', "#ffffff");
        document.documentElement.style.setProperty('--primary7-color', "#ffffff");
        document.documentElement.style.setProperty('--primary8-color', "#783f04");
        document.documentElement.style.setProperty('--primary9-color', "#000000");
        document.documentElement.style.setProperty('--primary10-color', "#F3DAA2");
        document.documentElement.style.setProperty('--primary11-color', "#783f04");
        document.documentElement.style.setProperty('--secondary1-active-color', "#C0C4CC");
        document.documentElement.style.setProperty('--secondary1-inactive-color', "#303133");
        document.documentElement.style.setProperty('--secondary2-active-color', "#909399");
        document.documentElement.style.setProperty('--secondary2-inactive-color', "#606266");
        document.documentElement.style.setProperty('--secondary3-active-color', "#5379f1");
        document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
        document.documentElement.style.setProperty('--secondary4-active-color', "#000000");
        document.documentElement.style.setProperty('--secondary4-inactive-color', "#273E95");
        document.documentElement.style.setProperty('--secondary5-active-color', "#5379f1");
        document.documentElement.style.setProperty('--secondary5-inactive-color', "#000000");
        document.documentElement.style.setProperty('--secondary6-active-color', "#5379f1");
        document.documentElement.style.setProperty('--secondary6-inactive-color', "#5379f1");
      document.documentElement.style.setProperty('--table-border-color', "#EBEEF5");
      }
    },
    branchLogo(to, from){
      this.logo = to
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$Tawk.$endChat();
    // console.log("beforeRouteLeave", to, from, next)
    // console.log(this.refreshPageAfter)
    // if (this.refreshPageAfter) {
    //   next(() => {
    //     location.reload();
    //   });
    // }
  }
};
</script>

<style lang="scss">
@import "./styles/variables.scss";
@font-face {
  font-family: College;
  src: url("./fonts/college/college.ttf");
}
@font-face {
  font-family: College;
  font-weight: bold;
  src: url("./fonts/college/collegeb.ttf");
}
@font-face {
  font-family: CaviarDreams;
  src: url("./fonts/caviar_dreams/CaviarDreams.ttf");
}
@font-face {
  font-family: CaviarDreams;
  font-weight: bold;
  src: url("./fonts/caviar_dreams/CaviarDreams_Bold.ttf");
}

.Cookie--xfero {
  background-color: #fff;
  color: #000;
  padding: 1.25em;
}
.Cookie--xfero .Cookie__button {
  border-radius: 4px;
  background: #000;
  padding: 0.625em 3.125em;
  color: #fff;
  border: 0;
  font-size: 1em;
}
.Cookie--xfero .Cookie__button:hover {
  background: #000;
}
.Cookie--xfero .Cookie__button:focus {
  background: #000;
}

.appLogo {
  max-height: 50px;
  max-width: 320px;
}

h1 {
  color: $color1;
}

.normal-text {
  color: #000;
  padding: 20px 2%;
}

.hyperlink {
  color: cyan;
}

.Cookie--dark-lime {
  background-color: #fff;
  color: #000;
}
.Cookie--dark-lime .Cookie__button {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}
.Cookie--dark-lime .Cookie__button:hover {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}
.Cookie--dark-lime .Cookie__button:focus {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}

.headerClass {
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-bottom-style: solid;
  height: 65px;
  padding: 0px 10%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: var(--bg10-color);
  .headerLink {
    display: block;
    font-size: 18px;
    color: var(--primary-color);
    padding-top: 15px;
    padding-right: 0px;
    padding-bottom: 16px;
    padding-left: 0px;
    text-align: center;
  }
}

.titleColor {
  color: $color1;
}
.titleColor:focus {
  color: $color1;
}
.titleColor:hover {
  color: $color1;
}
.rowTop {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  height: 56px;
  background-color: var(--bg-color);
}

.rowTop4 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 20px;
  height: 96px;
  background-color: var(--bg-color);
}

.companyList {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  background-color: var(--bg-color);
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  .companyButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    p {
      text-align: center;
    }
  }
  .companyButton:hover {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  }
  .companyButton.inactive {
    border: 1px solid var(--primary4-color);
    background-color: var(--bg-color);
    color: var(--secondary2-inactive-color);
    cursor: pointer;
  }
  .companyButton.active {
    border: 1px solid var(--primary5-color);
    background-color: var(--primary5-color);
    color: var(--primary2-color);
    cursor: inherit;
  }
}

.colorModeDiv {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--secondary3-inactive-color);
  position: absolute;
  right: 20px;
  .active {
    color: var(--secondary3-active-color);
  }
}

.el-dialog {
  margin-top: 5vh !important;
  margin-bottom: 15vh;
  border-style: solid;
  border-width: 4px;
  border-color: var(--bg6-color);
  border-radius: 10px;
  .el-input__inner {
    border-color: rgb(133, 133, 133);
  }
  // .el-input__inner:hover {
  //   border-color: var(--bg6-color);
  // }
  .el-textarea__inner {
    border-color: rgb(133, 133, 133);
  }
  // .el-textarea__inner:hover {
  //   border-color: var(--bg6-color);
  // }
  // .el-input__inner:hover {
  //   border-color: var(--bg6-color);
  // }
  // .el-input__suffix {
  //   color: var(--bg6-color);
  // }
  .el-input-number__decrease {
    border-color: rgb(133, 133, 133);
  }
  .el-input-number__increase {
    border-color: rgb(133, 133, 133);
  }
  .el-dialog__header {
    .el-dialog__title {
      font-size: 28px;
    }
  }
  .el-dialog__body {
    word-break: normal;
    padding-top: 0px;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .bigLabel {
    .el-form-item__label {
      font-size: 20px;
      line-height: 40px;
      margin-bottom: 10px;
    }
    .normalLabel {
      .el-form-item__label {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 0px;
      }
    }
  }
  .el-form-item {
    display: flex;
    flex-direction: column;
  }
  .el-form-item__label {
    color: var(--bg11-color);
    width: 100%;
    text-align: left;
    line-height: 20px;
  }
  .el-form-item__content {
    color: var(--bg11-color);
    margin-left: 0px;
    .el-date-editor.el-input {
      width: 100%;
    }
  }
  .el-button {
    border-color: var(--bg6-color);
    border-width: 2px;
    background-color: var(--bg5-color);
    color: var(--bg11-color);
  }
  .el-button--primary {
    border-color: var(--bg11-color);
    background-color: var(--bg11-color);
    color: var(--primary2-color);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    border-color: var(--bg11-color);
    background-color: var(--bg11-color);
    color: var(--primary2-color);
  }
  .el-button--beige {
    background-color: var(--primary4-color);
    border-color: var(--primary4-color);
    color: var(--bg12-color);
  }
  .el-button--beige:focus, .el-button--beige:hover {
    background-color: var(--primary4-color);
    border-color: var(--primary4-color);
    color: var(--bg12-color);
  }
  .row {
    flex-direction: row;
    .el-form-item__label {
      width: auto;
    }
    .el-form-item__content {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  @media screen and (max-width: 768px) {
    margin-top: 2vh !important;
    margin-bottom: 2vh !important;
    width: 90%;
  }
}
.el-textarea__inner {
  font-family: 'PublicaSans', sans-serif;
  color: var(--bg11-color);
  border-color: var(--bg6-color);
}
.el-textarea__inner:hover {
  border-color: var(--bg6-color);
}
.el-input__inner {
  font-family: 'PublicaSans', sans-serif;
  color: var(--bg11-color);
  border-color: var(--bg6-color);
  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #0f0;
  }
}
.el-input__inner:hover {
  border-color: var(--bg6-color);
}
.el-input__suffix {
  color: var(--bg6-color);
}
.el-input-number__decrease {
  font-family: 'PublicaSans', sans-serif;
  color: var(--bg11-color);
  border-color: var(--bg6-color);
  background-color: #FFEFCF;
}
.el-input-number__increase {
  font-family: 'PublicaSans', sans-serif;
  color: var(--bg11-color);
  border-color: var(--bg6-color);
  background-color: #FFEFCF;
}
.border2px {
  input {
    border-width: 2px;
  }
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f0f;
}
.el-button {
  font-family: 'PublicaSans', sans-serif;
  color: var(--bg11-color);
}
.el-button.is-disabled {
  border-color: #C0C4CC;
  background-color: #C0C4CC;
  color: #FFFFFF;
}
.el-button.is-disabled:focus, .el-button.is-disabled:hover {
  border-color: #C0C4CC;
  background-color: #C0C4CC;
  color: #FFFFFF;
}
.el-button--primary {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--primary:focus, .el-button--primary:hover {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--beige {
  background-color: var(--primary8-color);
  border-color: var(--primary8-color);
  color: var(--primary2-color);
}
.el-button--beige:focus, .el-button--beige:hover {
  background-color: var(--primary8-color);
  border-color: var(--primary8-color);
  color: var(--primary2-color);
}
.el-button--starbucks {
  background-color: var(--primary5-color);
  border-color: var(--primary5-color);
  color: var(--primary2-color);
}
.el-button--starbucks:focus, .el-button--starbucks:hover {
  background-color: var(--primary5-color);
  border-color: var(--primary5-color);
  color: var(--primary2-color);
}
.el-button--danger {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--danger:focus, .el-button--danger:hover {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--success {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--success:focus, .el-button--success:hover {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--warning {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--warning:focus, .el-button--warning:hover {
  border-color: var(--bg11-color);
  background-color: var(--bg11-color);
  color: var(--primary2-color);
}
.el-button--text {
  color: var(--primary11-color);
}
.el-button--text:focus, .el-button--text:hover {
  color: var(--primary4-color);
}

.el-collapse {
  border-color: var(--bg6-color);
}
.el-collapse-item__header {
  border-color: var(--bg6-color);
  background-color: #fff4cd;
  color: var(--bg11-color);
}
.el-collapse-item__wrap {
  border-color: var(--bg6-color);
  background-color: var(--bg-color);
}

.el-tag.el-tag--beige {
  background-color: rgba(0, 0, 0, 0);
  border-color: var(--primary4-color);
  color: var(--primary11-color);
}
.el-tag.el-tag--starbucks {
  background-color: rgba(0, 0, 0, 0);
  border-color: var(--primary5-color);
  color: var(--primary5-color);
}

.el-tag.el-tag--beige-tag {
  background-color: rgba(0, 0, 0, 0);
  border-color: var(--bg6-color);
  color: var(--primary11-color);
}
.el-tag.el-tag--beige-tag .el-tag__close {
  background-color: var(--primary10-color);
  color: var(--primary11-color);
}

/*Fixes double tap on iOS*/
.el-scrollbar__bar {
  opacity: 1!important;
}


input[type="checkbox"] {
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: 0;
  background: #fff;
  height: 12px;
  width: 12px;
  display: flex;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  border: 1px solid #767676;
  color: var(--primary2-color);
  border-radius: 2px;
  justify-content: center;
  align-items: center;
}

input[type="checkbox"]:checked {
  background: var(--primary5-color);
  border: 1px solid var(--primary5-color);
  color: var(--primary2-color);
}

input[type="checkbox"]:after {
  content: ' ';
  position: relative;
  left: 0%;
  top: 0%;
  width: 15%;
  height: 40%;
  border: solid var(--primary2-color);
  border-width: 0 2px 2px 0;
  transform: rotate(50deg);
  display: none;
}

input[type="checkbox"]:checked:after {
  display: block;
}

.footerClass {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  background-color: var(--bg-color);
  border-top: 1px solid #000;
  padding: 2px 0px;
}
.footer2Class {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  background-color: var(--bg-color);
  border-top: 1px solid #000;
  padding: 10px 10px;
}

.tagButton {
  display: flex; justify-content: center; align-items: center; border-width: 1.5px !important; height: 40px; margin-left: 2px !important; margin-right: 2px; margin-bottom: 10px; font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue